<template>
    <div class="page-login">
        <div class="login">
            <div class="login__inner">
                
                <div class="login__textbox">
                    <h1 class="login__title">Login</h1>

                    <div class="login__description">
                        <p><strong>We can provide whole process of making space from a sketch of an idea, design, visualization, furniture production and construction.</strong></p>
                    </div>

                    <form action="" id="form-login" class="form" @submit.prevent="onSubmit">
                        <fieldset class="form__fieldset">
                            <label for="name" class="form__label">Username</label>
                            <input v-model="username" type="text" name="name" class="form__textfield">
                        </fieldset>

                        <fieldset class="form__fieldset">
                            <label for="name" class="form__label">Password</label>
                            <input v-model="password" type="text" name="name" class="form__textfield">
                        </fieldset>

                        <button class="btn">Login</button>


                        <br>
                        <hr>
                        <p>Test output:</p>
                        <p><pre>{{ $data }}</pre></p>
                    </form>
                </div>

                <figure class="login__figure">
                    <!-- <img src="../assets/img-01.jpg" alt="" class="rspimg"> -->

                    <picture>
                        <source srcset="../assets/login.jpg" media="(min-width: 768px)">
                        <img srcset="../assets/login.jpg" alt="" class="rspimg">
                    </picture>


                </figure>
            </div>
        </div>

        <Prefooter />
        <Footer />
        
    </div>
</template>

<script>
// components
import Prefooter from '@/components/Prefooter.vue';
import Footer from '@/components/Footer.vue'

//import icons
import '@/compiled-icons/arrow-right';


export default {
    components: {
        Prefooter,
        Footer
    },

    data() {
        return {
            username: null,
            password: null
        }
    }
};
</script>


<style scoped lang="scss">
    @import "@/scss/modules/_login.scss";
</style>